<template>
  <v-select
    :value="optionSelected"
    :options="list"
    :class="{ 'select-size-sm': small }"
    :style="{ width: '90px' }"
    :disabled="isDisabled"
    :clearable="false"
    @input="onInput"
  />
</template>

<script>
export default {
  data() {
    return {
      list: [{
        label: 'Última',
        value: -1
      }].concat(Array.from(
        { length: this.pages },
        (_, index) => ({
          label: index + 1,
          value: index + 1
        })
      ))
    };
  },
  watch: {
    pages() {
      this.list = Array.from(
        { length: this.pages },
        (_, index) => ({
          label: index + 1,
          value: index + 1
        })
      );
    }
  },
  computed: {
    optionSelected() {
      return this.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled || !this.list.length;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event?.value);
    }
  },
  props: {
    pages: { type: Number, required: true },
    value: { type: Number, required: true },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false }
  },
};

</script>
